export const currencyList = [
    'AFN',
    'ALL',
    'DZD',
    'ARS',
    'AMD',
    'AUD',
    'AZN',
    'BHD',
    'BDT',
    'BYN',
    'BZD',
    'BOB',
    'BAM',
    'BWP',
    'BRL',
    'GBP',
    'BND',
    'BGN',
    'BIF',
    'KHR',
    'CAD',
    'CVE',
    'XAF',
    'CLP',
    'CNY',
    'COP',
    'KMF',
    'CDF',
    'CRC',
    'HRK',
    'CZK',
    'DKK',
    'DJF',
    'DOP',
    'EGP',
    'ERN',
    'EEK',
    'ETB',
    'EUR',
    'GEL',
    'GHS',
    'GTQ',
    'GNF',
    'HNL',
    'HKD',
    'HUF',
    'ISK',
    'INR',
    'IDR',
    'IRR',
    'IQD',
    'ILS',
    'JMD',
    'JPY',
    'JOD',
    'KZT',
    'KES',
    'KWD',
    'LVL',
    'LBP',
    'LYD',
    'LTL',
    'MOP',
    'MKD',
    'MGA',
    'MYR',
    'MUR',
    'MXN',
    'MDL',
    'MAD',
    'MZN',
    'MMK',
    'NAD',
    'NPR',
    'TWD',
    'NZD',
    'NIO',
    'NGN',
    'NOK',
    'OMR',
    'PKR',
    'PAB',
    'PYG',
    'PEN',
    'PHP',
    'PLN',
    'QAR',
    'RON',
    'RUB',
    'RWF',
    'SAR',
    'RSD',
    'SGD',
    'SOS',
    'ZAR',
    'KRW',
    'LKR',
    'SDG',
    'SEK',
    'CHF',
    'SYP',
    'TZS',
    'THB',
    'TOP',
    'TTD',
    'TND',
    'TRY',
    'USD',
    'UGX',
    'UAH',
    'AED',
    'UYU',
    'UZS',
    'VEF',
    'VND',
    'XOF',
    'YER',
    'ZMK',
    'ZWL'
];

export const currencyOptions = currencyList.map((item) => {
    return { label: item, value: item };
});
